export enum FingerprintEnum {
  DEFAULT = 'Unable to retrieve FP',
}

export const FingerprintSettings = {
  apiKey: 'nvoiB2OqFxGoBIg53MC6',
  endpoint: 'https://metrics.vipclub.lv',
  scriptUrlPattern: 'https://metrics.vipclub.lv/web/v3/nvoiB2OqFxGoBIg53MC6/loader_v3.11.1.js',
};
